// @flow

import * as React from "react"
import { Spin } from "antd"

class AsyncLoading extends React.Component<{}> {
  render(): React$Element<"div"> {
    return (
      <div className="co-async-loader">
        <Spin size="large" />
      </div>
    )
  }
}

export default AsyncLoading
